module.exports = __webpack_public_path__ + "img/CIO314_R.94267b37.png";